import * as z from "zod/v4";

export const sendRepairInvoice = {
  name: "sendRepairInvoice" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({}),
};
